import { Button, Center, Stack, Text, Title } from '@mantine/core'
import { IconError404 } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'

export default function NotFoundPage() {
  return (
    <Center h="100%">
      <Stack align="center" gap="md">
        <IconError404 size={96} />
        <Title order={1}>Ups! Nie ma takiej strony</Title>
        <Text c="dimmed" ta="center" maw={360}>
          Strona, której szukasz, nie istnieje lub została przeniesiona.
        </Text>
        <Button component={Link} to="/" size="md" radius="xl">
          Wróć na stronę główną
        </Button>
      </Stack>
    </Center>
  )
}
